export var defaultApiVersion = 20220511;
export var defaultEndpoints = {
    universalSearch: 'https://liveapi.yext.com/v2/accounts/me/answers/query',
    verticalSearch: 'https://liveapi.yext.com/v2/accounts/me/answers/vertical/query',
    questionSubmission: 'https://liveapi.yext.com/v2/accounts/me/createQuestion',
    status: 'https://answersstatus.pagescdn.com',
    universalAutocomplete: 'https://liveapi-cached.yext.com/v2/accounts/me/answers/autocomplete',
    verticalAutocomplete: 'https://liveapi-cached.yext.com/v2/accounts/me/answers/vertical/autocomplete',
    filterSearch: 'https://liveapi-cached.yext.com/v2/accounts/me/answers/filtersearch',
};
/**
 * The endpoints to use for sandbox experiences.
 *
 * @public
 */
export var SandboxEndpoints = {
    universalSearch: 'https://liveapi-sandbox.yext.com/v2/accounts/me/answers/query',
    verticalSearch: 'https://liveapi-sandbox.yext.com/v2/accounts/me/answers/vertical/query',
    questionSubmission: 'https://liveapi-sandbox.yext.com/v2/accounts/me/createQuestion',
    status: 'https://answersstatus.pagescdn.com',
    universalAutocomplete: 'https://liveapi-sandbox.yext.com/v2/accounts/me/answers/autocomplete',
    verticalAutocomplete: 'https://liveapi-sandbox.yext.com/v2/accounts/me/answers/vertical/autocomplete',
    filterSearch: 'https://liveapi-sandbox.yext.com/v2/accounts/me/answers/filtersearch',
};
//# sourceMappingURL=constants.js.map